//import { InputDataListS } from "../../../vehicle-control-group/request/modal/SearchVehicleModal";
import { InputDataListS } from "../../../../components/modal/SearchFormModal";

const FilterOptions: {
  value: string;
  label: string;
}[] = [
  {
    value: "unityId",
    label: "Unidad",
  },
  {
    value: "operator",
    label: "Agente",
  },
];

export const SearchAttendanceInputList: InputDataListS = [
  {
    name: "filter",
    type: "select",
    label: "Buscar por",
    options: FilterOptions,
    cleanable: false,
  },
  {
    name: "search",
    type: "keyword",
    label: "Palabra Clave",
    placeholder: "Ingrese busqueda",
    defaultValue: "",
  },
  {
    name: "dpInicio",
    type: "datepicker",
    label: "Desde",
  },
  {
    name: "dpFinal",
    type: "datepicker",
    label: "Hasta",
  },
  {
    name: "searchInAll",
    type: "checkbox",
    label: "Todos los Registros",
    defaultValue: false,
  },
];
